module.exports = __webpack_public_path__ + "img/redeemed.e691c2f0.png";